/**
 * Адреса правки общего товара (`CatalogProductEditController`, RP-FB50). Литерал `/api/` законен только в файлах
 * `api/urls.ts` (eslint). Идентификатор товара приходит из адреса окна — ввод человека: кодируется.
 */
const BASE = '/api/platform/v1/catalog/products'

export const PLATFORM_COMMON_PRODUCT_URLS = {
  products: BASE,
  one: (productId: string) => `${BASE}/${encodeURIComponent(productId)}`,
} as const
